import { deviceAdminApi } from '@/api';
import { buildColumn, ColumnsProps, handleResponse, ScrollType } from '@/Helper';
import { DoorGroupDoorInfo } from '@/model/DeviceAdminModel';
import { Logger } from '@/model/LoggingModel';
import { Empty, Spin, Table } from 'antd';
import { TableLocale } from 'antd/es/table/interface';
import React, { FC, useEffect, useState } from 'react';
import styles from '../../credentialmodal.module.scss';

type Props = {
	doorGroupId: number;
	hasPermission?: boolean;
	scroll?: ScrollType;
	hideExpandColumn?: boolean;
};

const DoorGroupInfoTable: FC<Props> = ({ doorGroupId, hideExpandColumn, hasPermission = true }) => {
	//#region State Management Variables
	const [doorGroupDoors, setDoorGroupDoors] = useState<DoorGroupDoorInfo[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	//#endregion

	useEffect(() => {
		if (hasPermission) {
			setIsLoading(true);
			deviceAdminApi
				.getDoorGroupInfo(doorGroupId)
				.then(response => {
					if (!handleResponse(response)) {
						setDoorGroupDoors(response.DoorGroupDoors);
					} else {
						Logger.writeErrorLog(response.ErrorMessage);
					}
				})
				.catch(error => {
					Logger.writeErrorLog(error);
				})
				.finally(() => setIsLoading(false));
		} else {
			setDoorGroupDoors([]);
		}
	}, [doorGroupId]);

	const columns: ColumnsProps<DoorGroupDoorInfo>[] = [
		{
			title: '',
			dataIndex: 'expand',
			width: 50,
			hidden: hideExpandColumn,
		},
		{
			...buildColumn(_('Address'), 'DoorAddress', '240px', 'start'),
		},
		{
			...buildColumn(_('Readers'), 'ReaderName', '290px', 'start'),
		},
		{
			...buildColumn(_('TimeZone'), 'TimeZoneName', 'auto', 'start'),
		},
	];

	const emptyMessage: string = hasPermission ? 'No Data' : _('DisabledButtonPermissionsWarning');
	const tableLocale: TableLocale = { emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyMessage} /> };

	return (
		<Spin spinning={isLoading} tip={_('Loading')}>
			<Table
				id='doorGroupDoorsTable'
				size='small'
				columns={columns}
				dataSource={doorGroupDoors}
				pagination={false}
				className={styles.doorGroupTable}
				locale={tableLocale}
			/>
		</Spin>
	);
};

export { DoorGroupInfoTable };
